<template>
	<el-drawer title="绑定角色" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="80%"
		@close="close">
		<div class="drawer-content">
			<div class="page-filter-box">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
						<el-input v-model="inputKeyword" placeholder="角色名称" size="small"></el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch"
							size="small">查询</el-button>
						<el-button type="default" icon="el-icon-refresh" @click="handleReset"
							size="small">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<el-form :model="formData" :rules="rules" ref="formData" label-position="top">
				<el-form-item prop="roleIdList" label="选择角色:">
					<el-checkbox-group v-model="formData.roleIdList">
						<el-row :gutter="40">
							<el-col v-for="item in filteredList" :key="item.id" :xs="12" :sm="8" :md="6" :lg="6"
								:xl="3">
								<el-checkbox :label="item.id">{{
                                    item.roleName
                                }}</el-checkbox>
							</el-col>
						</el-row>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="submitForm()" :loading="loading">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
	const defaultFormData = {
		id: "",
		roleIdList: [],
	};
	export default {
		data() {
			return {
				drawerShow: false,
				loading: false,
				formData: {
					...defaultFormData
				},
				rules: {
					// roleIdList: [{ required: true, message: "请选择角色" }],
				},
				roleIdList: [],
				params: {
					keyWords: ''
				},
				inputKeyword: '',
			};
		},
		computed: {			
			filteredList: function() {
				var self = this;
				var keyword = (self.params.keyWords || '').trim().toLowerCase();				
				if (keyword === '') {
					return self.roleIdList;
				}
				return self.roleIdList.filter(function(role) {
					var name = (role.roleName || '').toLowerCase();
					return name.indexOf(keyword) !== -1;
				});
			}
		},
		methods: {
			close() {
				this.formData = {
					...defaultFormData
				};
				this.$refs.formData.resetFields();
				this.drawerShow = false;
				this.handleReset()
			},
			show(itemData) {
				this.formData = {
					roleIdList: [],
					id: itemData.id,
				};
				this.roleIdList = itemData.roleList || [];
				this.roleIdList.map(item => {
					if (item.binded == 1) {
						this.formData.roleIdList.push(item.id);
					}
				})

				this.drawerShow = true;
			},			
			handleSearch() {
				this.params.keyWords = this.inputKeyword;
			},			
			handleReset() {
				this.inputKeyword = '';
				this.params.keyWords = '';
			},
			//表单提交
			submitForm() {
				let self = this;
				self.$refs["formData"].validate((valid) => {
					if (valid) {
						const _url = "/adminUser/bindingRole";
						this.loading = true;
						this.$request({
								url: _url,
								data: this.formData,
								method: "post",
							})
							.then((res) => {
								const {
									state,
									msg
								} = res.data;
								if (state == 1) {
									this.$emit("update");
									self.close();
								} else {
									self.$message.error(msg || "操作失败,请重试");
								}
							})
							.catch(() => {
								self.$message.error("操作失败,请重试");
							})
							.finally(() => {
								this.loading = false;
							});
					} else {
						return false;
					}
				});
			},
		},
	};
</script>